"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhoneCall = function PhoneCall(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "25",
    height: "25",
    fill: props.backgroundColor
  }), _react.default.createElement("g", {
    opacity: "0.5"
  }, _react.default.createElement("path", {
    d: "M13.5311 16.0697L14.5811 15.0197C14.7217 14.8791 14.9004 14.7829 15.0951 14.7429C15.2898 14.7029 15.492 14.7209 15.6766 14.7947L16.9554 15.3066C17.1438 15.382 17.3054 15.5121 17.4192 15.6802C17.533 15.8483 17.5938 16.0467 17.5938 16.2497V18.5752C17.5941 18.7134 17.5662 18.8502 17.5119 18.9773C17.4575 19.1043 17.3777 19.219 17.2775 19.3141C17.1773 19.4093 17.0587 19.4831 16.929 19.5308C16.7993 19.5786 16.6612 19.5993 16.5232 19.5919C7.55973 19.0341 5.74941 11.4422 5.41332 8.535C5.39704 8.39288 5.41104 8.24891 5.45439 8.11258C5.49774 7.97625 5.56946 7.85065 5.66484 7.74402C5.76021 7.6374 5.87708 7.55218 6.00776 7.49396C6.13843 7.43575 6.27995 7.40585 6.42301 7.40625H8.70723C8.91023 7.40625 9.10858 7.46707 9.27668 7.58086C9.44479 7.69466 9.57494 7.85622 9.65035 8.04469L10.1618 9.32344C10.2356 9.50802 10.2536 9.7102 10.2136 9.90493C10.1736 10.0997 10.0773 10.2784 9.93676 10.4189L8.88676 11.4689C8.88676 11.4689 9.46895 15.562 13.5311 16.0697Z",
    fill: props.foregroundColor
  })), _react.default.createElement("path", {
    d: "M15.5459 11.0521C15.5769 11.7468 14.4956 11.6955 14.4978 11.0977C14.5 10.4998 14.2961 10.2884 13.9886 10.0065C13.681 9.72455 13.2146 9.68785 12.8573 9.59384C12.5 9.49984 12.117 8.57509 12.8118 8.54573C13.5065 8.51638 14.1193 8.70404 14.697 9.23364C15.2748 9.76324 15.5149 10.3575 15.5459 11.0521Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M18.1663 10.9382C18.2282 12.3276 17.0499 12.0694 17.0018 10.9888C16.9536 9.90825 16.5801 8.98381 15.6814 8.15998C14.7827 7.33615 13.8293 7.04425 12.7487 7.08998C11.668 7.13571 11.3086 5.98425 12.698 5.92541C14.0875 5.86658 15.4436 6.36132 16.4687 7.30108C17.4939 8.24085 18.1044 9.54889 18.1663 10.9382Z",
    fill: props.foregroundColor
  }));
};

PhoneCall.defaultProps = {
  altText: "Phone Call",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
PhoneCall.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = PhoneCall;
exports.default = _default;